// src/client/AppShell.tsx
export default function AppShell({
  children,
  disableTopInset = false,
}: {
  children: React.ReactNode;
  disableTopInset?: boolean;
}) {
  const isIOS =
    typeof navigator !== "undefined" &&
    /iphone|ipad|ipod/i.test((navigator.userAgent || "").toLowerCase());
  const topInset = disableTopInset ? 0 : (isIOS ? 90 : 0);

  return (
    <div
      className="min-h-screen w-full bg-gradient-to-b from-[#0f2a3c] via-[#0f2434] to-[#2b1740] safe-top safe-x"
      style={{ ["--app-top-inset" as any]: `${topInset}px` }}
    >
      {/* одинаковые отступы: слева/справа и сверху; низ можно оставить как есть */}
      <div
        className="px-4 sm:px-5 pb-4"
        style={{ paddingTop: `calc(${topInset}px + 16px)` }}
      >
        {children}
      </div>
    </div>
  );
}
